import { useAdminAuth } from "@auth/AuthContext"
import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"

// Keeps an already-logged-in admin off /login (bounces to the dashboard).
export function GuestRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAdminAuth()
  return isAuthenticated ? <Navigate to="/" replace /> : <>{children}</>
}
